import {Component} from "react";
import {injectIntl} from "react-intl";
import connect from "react-redux/es/connect/connect";
import {withRouter} from 'react-router-dom'
import React from "react";
import {Select, Card, Row, Col, Spin, Tooltip, Popover} from "antd";
// Radios
import { Router, Link } from 'react-router-dom'
import history from "../../History";
import moment from 'moment'
import BunkeyAPI from '../../api/BunkeyAPI'
import { sendNotification, processDownloadHistory } from '../../utils'
import {
  handleMineOrAll,
  handleDefaultListDownloadHistory,
  handleRefreshDownloadHistory,
  handleIsFetchingHistory,
} from '../../actions/DownloadAction'
import { getSearchResult } from '../../actions/SearchAction'
import './dashboard-download-history.css'

const { Option } = Select
const spinnerStyle = {
  textAlign: 'center',
  borderRadius: 4,
  marginBottom: 20,
  padding: '30px 50px',
  margin: '20px 0'
}
export class DashboardDownloads extends Component {

  _isMounted = false;
  
  constructor(props) {
    super(props)
    this.state = {
      breadCrumbs: [],
      order: {
        field: ['createdAt'],
        type: 'asc',
        limit: 30,
        page: 1,
      },
      downloadHistory: [],
      filter_selected: 'all',
      isFetchingHistoryLocal: false
    }
  }

  componentDidMount() {
    this._isMounted = true;
    const { order } = this.state
    const query = []
    this.handleFilterChange('all', order, query)
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleFilterChange = filter => {
    const { order } = this.state
    const { user, workclient, intl } = this.props
    this.setState({
      isFetchingHistoryLocal: true
    })
    let query = [{
      field: 'user',
      type: 'eq',
      value: user._id,
    }]
    switch (filter) {
      case 'videos':
        query = [
          ...query, {
            field: 'type',
            type: 'eq',
            value: 'video',
          },
          {
            field: 'status',
            type: 'eq',
            value: 'success',
          },
        ]
        break;
      case 'images':
        query = [
          ...query, {
            field: 'type',
            type: 'eq',
            value: 'image',
          },
          {
            field: 'status',
            type: 'eq',
            value: 'success',
          },
        ]
        break;
      case 'documents':
        query = [
          ...query, {
            field: 'type',
            type: 'eq',
            value: 'document',
          },
          {
            field: 'status',
            type: 'eq',
            value: 'success',
          },
        ]
        break;
      case 'folders':
        query = [
          ...query, {
            field: 'type',
            type: 'eq',
            value: 'folder',
          },
          {
            field: 'status',
            type: 'eq',
            value: 'success',
          },
        ]
        break;
      case 'notDownloaded':
        query = [
          ...query, {
            field: 'status',
            type: 'eq',
            value: 'error',
          },
        ]
        break;
      default:
        query = [
          ...query,
          {
            field: 'status',
            type: 'eq',
            value: 'success',
          },
        ]
        break;
    }
    query.shift()
    BunkeyAPI({
      url: query
        ? `/downloads/client/${workclient}?q=${JSON.stringify(query)}&order=${JSON.stringify(order)}`
        : `/downloads/client/${workclient}?order=${JSON.stringify(order)}`,
      method: 'GET',
    }).then(resp => {
      const { data } = resp;
      if(!this._isMounted) return;
      this.setState({ downloadHistory: processDownloadHistory(data) })
      this.setState({
        isFetchingHistoryLocal: false
      })
    }).catch(err => {
      sendNotification('error', intl, intl.formatMessage({ id: 'error_getting_downloads_list' }));
      if(!this._isMounted) return;
      this.setState({
        isFetchingHistoryLocal: true
      })
    })
  }
  handleGetBreadCrumbs = item => {
    const { breadcrumb } = this.props
    let route = []
    // --->
    item.parents.forEach(i => {
      breadcrumb.forEach(b => {
        if (i === b._id)
          route.push({ id: b._id, name: b.name })
      })
    })
    // --->
    return route
  }
  handleGoToAsset = asset => {
    const { document: { client, _id, name } } = asset
    this.props.getSearchResult(client, name, '', 1, null, _id)
    // this.props.handleShowHideDetailDrawer()
  }
  render() {
    const {
      user,
      intl,
      newColor,
      root,
    } = this.props
    const { filter_selected, isFetchingHistoryLocal } = this.state
    const { downloadHistory } = this.state
    const isOperator = user.role !== 'admin' && user.clientRole !== 'admin'
    return (
      <React.Fragment>
        <Card className="dashboard-download card-download-cp" title={intl.formatMessage({id: 'download_history'})} hoverable
          style={{minHeight: "295px"}}>
          <Row gutter={25} style={{marginTop: "0px"}}>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Select defaultValue={ filter_selected }
                className='arrowSelect'
                onChange={this.handleFilterChange}
                style={{ size: 'small', width: 130, color: newColor }}
                dropdownStyle={{ position: "fixed" }}>
                <Option value="all">{intl.formatMessage({ id: "all" })}</Option>
                <Option value="videos">{intl.formatMessage({ id: "searche_tooltip_video" })}</Option>
                <Option value="images">{intl.formatMessage({ id: "searche_tooltip_image" })}</Option>
                <Option value="documents">{intl.formatMessage({ id: "documents" })}</Option>
                <Option value="folders">{intl.formatMessage({ id: "folders" })}</Option>
                <Option value="notDownloaded">{intl.formatMessage({ id: "notDownloaded" })}</Option>
              </Select>
            </Col>
          </Row>
          <Row>
            <Router history={history}>
              <div className='dh-container-list-download css-color-bunkers-download' style={{overflow: 'auto', overflowX: 'hidden', maxHeight: '297px', scrollbarTrackColor: 'white', marginTop: '10px', paddingRight:'10px'}}>
                {isFetchingHistoryLocal && <div style={spinnerStyle}><Spin spinning={isFetchingHistoryLocal} /></div>}
                {!isFetchingHistoryLocal && <ul>
                  {downloadHistory.map((d, k) => <div key={k}>
                    {d.typeItem === 'date' && <div className='dh-container-badge-download '>
                      <p className='dh-badge-download'>{moment(new Date()).format('DD/MM/YYYY') === moment(d.date).format('DD/MM/YYYY')
                        ? intl.formatMessage({ id: 'today' })
                        : `${moment(d.date).format('dddd')}  ${moment(d.date).format('DD/MM/YYYY')}`}</p>
                    </div>}
                    {d.typeItem === 'download' && <span>
                      <Tooltip
                        placement="top"
                        title={intl.formatMessage({ id: 'go_to_asset' })}
                        overlayStyle={{ fontSize: '10px' }}>
                        <div
                          data-icon="a"
                          className="icon"
                          style={{ marginRight: 10, float: 'right', cursor: 'pointer', marginTop: 7}}
                          onClick={() => this.handleGoToAsset(d)}></div>
                      </Tooltip>
                      <Popover placement="left" content={<div className='dh-popover-download'>
                        <p>
                          <b>{intl.formatMessage({ id: 'name' })}:</b> <span>{d.name.length > 40
                            ? `${d.name.substring(0, 37)}...`
                            : d.name}
                          </span>{d.type === 'folder' && <span>.zip</span>}
                        </p>
                        {d.document.fileSizeFormat && <p>
                          <b>{intl.formatMessage({ id: 'weight' })}:</b> <span>{d.document.fileSizeFormat}</span>
                        </p>}
                        {!isOperator && <p>
                          <b>{intl.formatMessage({ id: 'download_by' })}:</b> <span>{d.user_creator.name}</span>
                        </p>}
                        {<p>
                          <b>{intl.formatMessage({ id: 'type' })}:</b> <span>{
                            d.typeItem === 'download' && d.type !== 'folder'
                              ? d.document.originalURL.split('.').slice(-1)
                              : intl.formatMessage({ id: 'folder' })
                          }</span>
                        </p>}
                        <p>
                          <b>{intl.formatMessage({ id: 'asset_location' })}:</b><span>
                            <span><Link
                              to={`/home/`}
                              style={{ fontSize: 13, cursor: 'pointer', color: 'rgba(0, 0, 0, 0.65)', textDecoration: 'underline' }}>
                              {intl.locale === 'es' ? '/Bunkers/' : '/Home/'}
                            </Link></span>
                            {
                              this.handleGetBreadCrumbs(d.document).map((r, k) => <Link to={`/home/explore/${r.id}`}
                                key={k}
                                style={{ fontSize: 13, cursor: 'pointer', color: 'rgba(0, 0, 0, 0.65)', textDecoration: 'underline' }}>
                                {r.name}/
                            </Link>)
                            }</span>
                          {d.location === root && <Link
                            to={`/home/explore/${d.document._id}`}
                            style={{ fontSize: 13, cursor: 'pointer', color: 'rgba(0, 0, 0, 0.65)', textDecoration: 'underline' }}>
                            {d.document.name}
                          </Link>}
                        </p>
                        {/* <p><b>{intl.formatMessage({ id: 'times_downloaded' })}:</b> <span> -- </span></p> */}
                      </div>} title="Title">
                        {/* style={{ backgroundColor: k % 2 !== 0 ? '#f2f2f2' : '#fffff' }} */}
                        <li key={k} className='dh-li-download' >
                          {d.name.length > 40
                            ? `${d.name.substring(0, 37)}...`
                            : d.name}
                          {d.type === 'folder' && <span>.zip</span>}
                        </li>
                      </Popover>
                    </span>}
                  </div>)}
                </ul>}
                {!isFetchingHistoryLocal && downloadHistory.length === 0 && <div style={{ textAlign: 'center' }}>
                  <p>{intl.formatMessage({ id: 'no_download_data' })}</p>
                </div>}
              </div>
            </Router>
          </Row >
        </Card>
      </React.Fragment>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    newColor: state.authUser.user && state.authUser.user.color ? state.authUser.user.color : '#2E97CF',
    defaultListDownloadHistory: state.downloads.defaultListDownloadHistory,
    user: state.authUser.user,
    isFetchingHistory: state.downloads.isFetchingHistory,
    mine: state.downloads.mine,
    breadcrumb: state.client.breadcrumb,
    root: state.client.root,
    workclient: state.client.workclient,
    refreshDownloadHistory: state.downloads.refreshDownloadHistory,
  }
};

const mapDispatchToProps = {
  handleMineOrAll,
  getSearchResult,
  handleDefaultListDownloadHistory,
  handleRefreshDownloadHistory,
  handleIsFetchingHistory,
};

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(DashboardDownloads)))
